<template>
  <v-card
    class="v-base-card pa-3"
    elevation="3"
    :class="$slots.heading ? this.mt : 'mt-5'"
  >
    <v-sheet
      v-if="$slots.heading"
      class='v-base-card__heading mb-n6 pa-7'
      max-height="5"
      width='100%'
      dark
    >
      <slot name="heading"/>
    </v-sheet>

    <div class="v-base-card__subtitle" v-if="$slots.subtitle">
      <v-card-subtitle>
        <slot name="title"/>
      </v-card-subtitle>
    </div>

    <div class="v-base-card__content">
      <slot
        v-if="$slots.content"
        name="content"
      />
    </div>
  </v-card>
</template>

<script>
  export default {
    name: 'BaseCard',

    props: {
      mt: {
        type: String,
        default: 'mt-15',
      },
    },
  }
</script>

<style lang="stylus" scoped>
  .v-base-card
    &__heading
      box-shadow 0px 1px 5px 1px #767373
      line-height 5px
      border-radius 5px !important
      position relative
      top -40px
      transition .3s ease
      z-index 1
      color white
      background-image linear-gradient(to right, #4476aa, #2364a2)
      font-weight bold

    &__content
      padding 5px 20px
</style>
